import { Box, Card, Link, List, Text } from '@ksyos/design-system';
import { ExternalLink } from '../../elements/atoms/externalLink/ExternalLink';
import { PageTitle } from '../../elements/atoms/pageTitle/PageTitle';
import { PageWrapperWithHeader } from '../../elements/organisms/pageWrapper/PageWrapperWithHeader';

export function OsasDentistInformation() {
    return (
        <PageWrapperWithHeader>
            <PageTitle>Afspraak met de tandarts</PageTitle>
            <Card>
                <Card.Body>
                    <Box maxWidth={620}>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            size="md"
                        >
                            Zo maak je een afspraak met de tandarts
                        </Text>
                        <List styleType="bullet">
                            <List.Item>
                                Ga naar de keuze-pagina van de gespecialiseerde tandartsen op:
                                <Link
                                    color="primary"
                                    fontWeight="normal"
                                    href="https://www.nvts.nl/patienten/nvts-geaccrediteerde-behandelaren"
                                    openInNewTab
                                    variant="externalLink"
                                >
                                    https://www.nvts.nl/patienten/nvts-geaccrediteerde-behandelaren
                                </Link>{' '}
                                en vul je postcode of woonplaats in.
                            </List.Item>
                            <List.Item>Kies een tandarts en maak een afspraak door te bellen.</List.Item>
                        </List>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            mt={4}
                            size="md"
                        >
                            Begeleiding door de tandarts
                        </Text>
                        De gespecialiseerde tandarts maakt de beugel precies passend voor jou en begeleidt je om hem
                        goed te gebruiken.
                        <Box mt={4}>
                            Neem contact op met Ksyos als:
                            <List styleType="bullet">
                                <List.Item>De klachten van je slaapapneu niet afnemen na drie maanden.</List.Item>
                                <List.Item>Je de beugel niet verdraagt.</List.Item>
                            </List>
                            Je kunt ons bellen op <ExternalLink href="tel:020-2366533">020 600 00 60</ExternalLink>. We
                            zijn bereikbaar van maandag tot en met vrijdag tussen 8:30 en 17:00 uur.
                        </Box>
                    </Box>
                </Card.Body>
            </Card>
        </PageWrapperWithHeader>
    );
}
